import styled from 'styled-components';
import { StyledButton } from "../../../components/Buttons/DefaultButton/DefaultButton.styles";

export const StyledOkButton = styled(StyledButton)`
    min-width: 20rem;
    max-width: 24rem;
    align-self: center;

    @media only screen and (min-width: 900px) {
        margin-top: 2rem !important;
    }
`
export const StyledDescription = styled.li`
    font-size: 1rem;
    margin-bottom: 1rem;
`

export const StyledList = styled.ul`
    margin-bottom: 2rem;
`